'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { missingHeadshotCodes, playerCodes } from './_data';
import { initials } from './format';
export function PlayerPortrait(t0) {
  const $ = _c(14);
  const {
    player,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const code = playerCodes[player];
  let t2;
  if ($[0] !== code) {
    t2 = code && !missingHeadshotCodes.has(code);
    $[0] = code;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const hasHeadshot = t2;
  const dimensions = size === "lg" ? "h-24 w-20" : size === "sm" ? "h-14 w-12" : "h-20 w-16";
  const t3 = `${dimensions} relative flex shrink-0 items-end justify-center overflow-hidden border border-[#24122f] bg-[#eadfcf]`;
  let t4;
  if ($[2] !== player) {
    t4 = initials(player);
    $[2] = player;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <span className="absolute inset-0 flex items-center justify-center text-xs font-black text-[#24122f]/60">{t4}</span>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== code || $[7] !== hasHeadshot || $[8] !== player) {
    t6 = hasHeadshot && <Image src={`/fantasy/headshots/p${code}.png`} alt={`${player} headshot`} width={80} height={96} className="relative size-full object-contain object-bottom" onError={_temp} />;
    $[6] = code;
    $[7] = hasHeadshot;
    $[8] = player;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t5 || $[12] !== t6) {
    t7 = <div className={t3}>{t5}{t6}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp(event) {
  event.currentTarget.style.display = "none";
}